import React from "react";
import Navigationbar from "../layouts/navigationbar";

function LivePage() {
  return (
    <div>
      <Navigationbar openStatus={false} />
      <div>Live page</div>
    </div>
  );
}

export default LivePage;
